import React, { useEffect, useState, useRef } from 'react';
import baseURL from '../url';
import './Products.css';
// Eliminamos las importaciones de Swiper
// import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/swiper-bundle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'; // Mantenemos solo el que se usa en la grilla seleccionada
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProductosLoading from '../ProductosLoading/ProductosLoading';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
import VenderAuto from '../VenderAuto/VenderAuto';
import BuscarCeroKm from '../BuscarCeroKm/BuscarCeroKm';
import PorQueElegirnos from '../PorQueElegirnos/PorQueElegirnos';
import Financiacion from '../Financiacion/Financiacion';
import Ubicacion from '../Ubicacion/Ubicacion';
import ComprarMoto from '../ComprarMoto/ComprarMoto';

// Eliminamos la inicialización de SwiperCore
// SwiperCore.use([Navigation, Pagination, Autoplay]);

// Componente para la Tarjeta de Producto (Destacado)
const ProductCard = ({ item }) => {
    // Función para obtener la imagen (la dejamos aquí para que el código sea más limpio)
    const obtenerImagen = (prod) => {
        if (prod.imagen1) {
            return prod.imagen1;
        } else if (prod.imagen2) {
            return prod.imagen2;
        } else if (prod.imagen3) {
            return prod.imagen3;
        } else if (prod.imagen4) {
            return prod.imagen4;
        }
        return null;
    };

    return (
        <Anchor className='cardProdcutmasVendido' to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`}>
            <img src={obtenerImagen(item)} alt="imagen" />
            <h6 className='masVendido'>DESTACADOS</h6>
            <div className='cardText'>
                <h4>{item.titulo}</h4>
                <span>{item.descripcion}</span>
                <div className='deFLexPrice'>
                    <h5> {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                    {(item.precioAnterior >= 1 && item.precioAnterior !== undefined) && (
                        <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                    )}
                </div>
            </div>
        </Anchor>
    );
};

export default function Products() {
    const [categorias, setCategorias] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fixedCategories, setFixedCategories] = useState(false);
    const categoriasRefs = useRef([]);
    const categoriasInputRef = useRef(null);
    const [productos, setProductos] = useState([]);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('Destacados');

    const handleClickCategoria = (categoria) => {
        setCategoriaSeleccionada(categoria);
    };

    useEffect(() => {
        cargarProductos();
        cargarCategorias();

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleScroll = () => {
        if (categoriasInputRef.current) {
            if (window.scrollY > categoriasInputRef.current.offsetTop) {
                setFixedCategories(true);
            } else {
                setFixedCategories(false);
            }
        }
    };

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php?soloActivos=1`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos);
                setLoading(false);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const obtenerImagen = (item) => {
        if (item.imagen1) {
            return item.imagen1;
        } else if (item.imagen2) {
            return item.imagen2;
        } else if (item.imagen3) {
            return item.imagen3;
        } else if (item.imagen4) {
            return item.imagen4;
        }
        return null;
    };

    const categoriasConProductos = categorias.filter(categoria =>
        productos?.some(producto => producto?.idCategoria === categoria?.idCategoria)
    );

    // const allCategorias = categorias; // Esta línea no se utiliza, se puede eliminar.

    return (
        <>
            {/* Sección de título destacados */}
            <div className='vehiculos-destacados-section speed'>
                <h1 className='vehiculos-destacados-title'>MOTOS DESTACADAS</h1>
                {/*<p className='vehiculos-destacados-subtitle'>Aprovechá estas oportunidades únicas, no aparecen todos los días.</p>*/}
            </div>

            <div className='ProductsContain'>
                <ToastContainer />

                {loading ? (
                    <ProductosLoading />
                ) : (
                    <div className='Products'>
                        {/* Seccion de Vehículos Destacados (en Grilla) */}
                        {categoriaSeleccionada === 'Destacados' && (
                            <>
                                {productos?.some(item => item.masVendido === "si") && (
                                    <div className='categoriSection'>
                                        {/* Este contenedor ahora será la GRISHA DE DESTACADOS */}
                                        <div className='productos-destacados-grilla'>
                                            {productos
                                                ?.filter(item => item.masVendido === "si")
                                                // 🚨 AQUÍ SE APLICA EL LÍMITE DE 4 ELEMENTOS
                                                .slice(0, 4)
                                                // 🚨 FIN DEL LÍMITE
                                                .map(item => (
                                                    <ProductCard key={item.idProducto} item={item} />
                                                ))}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}

                        {/* Seccion de Categoría Seleccionada (ya estaba en Grilla/Lista) */}
                        <div className='categoriSectionSelected'>
                            {productos
                                ?.filter(item => categoriaSeleccionada !== 'Destacados' && item.idCategoria === categoriaSeleccionada)
                                ?.map(item => (
                                    <Anchor key={item.idProducto} to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`}>
                                        <div className='cardProdcutSelected'>
                                            <img src={obtenerImagen(item)} alt="imagen" />
                                            <div className='cardTextSelected'>
                                                <h4>{item.titulo}</h4>
                                                <span>{item.descripcion}</span>
                                                <div className='deFLexPrice'>
                                                    <h5> {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                    {(item.precioAnterior >= 1 && item.precioAnterior !== undefined) && (
                                                        <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                    )}
                                                </div>
                                                <FontAwesomeIcon icon={faAngleDoubleRight} className='iconCard' />
                                            </div>
                                        </div>
                                    </Anchor>
                                ))}
                        </div>
                    </div>
                )}
            </div>

            {/*<VenderAuto />*/}
            <BuscarCeroKm />
            {/*<PorQueElegirnos />*/}
            <ComprarMoto />
            <Financiacion />
            <Ubicacion />


        </>
    );
}